<app-breadcrumb [title]="'Tarjetas y Cuentas'" [breadcrumb]="'Métodos de Pago'"></app-breadcrumb>
<!-- personal deatail section start -->
<section class="contact-page register-page">
    <div class="container">
        <div class="row mt-2">
            <div class="col-md-4" *ngFor="let n of metodos">
                <div class="credit-card"
                    [ngClass]="{'credit-card-visa': n.brand == 'visa', 'credit-card-master':  n.brand == 'mastercard' , 'credit-card-america':  n.brand == 'american_express'}">
                    <div class="card-front">
                        <div class="chip">
                            <img src="https://i.ibb.co/G9pDnYJ/chip.png" style="width: 26px !important;">
                            <img class="pull-right"
                                src="https://brandemia.org/sites/default/files/inline/images/american_express_logo_wordmark_detail.png" style="width: 26px !important;" *ngIf="n.brand == 'american_express'">
                            <img class="pull-right" src="https://i.ibb.co/WHZ3nRJ/visa.png" width="80px" *ngIf="n.brand == 'visa'"  style="width: 26px !important;">
                            <img class="pull-right" src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/MasterCard_logo.png/320px-MasterCard_logo.png" width="80px" *ngIf="n.brand == 'mastercard'" style="width: 26px !important;">
                        </div>
                        <div class="card-number">
                            <span>••••</span>
                            <span>••••</span>
                            <span>••••</span>
                            <span>{{n.last4}}</span>
                        </div>
                        <div class="card-info">
                            <div class="card-holder">
                                <label>Titular</label>
                                <p class="blanco">{{n.name}}</p>
                            </div>
                            <div class="card-expiration">
                                <label>Valida Hasta</label>
                                <p class="blanco">{{n.expMonth}}/{{n.expYear}}</p>
                            </div>
                        </div>
                    </div>&nbsp;
                </div>
                <br>
                <a class="mt-4 rojo" (click)="eliminarTarjeta(n)" style="cursor:pointer;" name="Eliminar"><i class="fa fa-trash"></i>&nbsp;Eliminar Tarjeta</a>
            </div>
        </div>
        <br>
        <br>
        <div class="row">
            <form class="form-inline subscribe-form">
                <div class="form-group mx-sm-3">
                    <button class="btn btn-danger pull-right" (click)="registrarNueva()"><i class="fa fa-plus"></i>&nbsp;Agregar método de pago</button>
                </div>
                <p><u>Aceptamos la mayoría de las tarjetas de crédito y débito.</u></p>
            </form> 
        </div>
        <br>
    </div>
</section>